import styled from 'styled-components';

export const VolleyCalendarContainer = styled.div`
  text-align: center;
  width: 100%;
  min-width: 270px;
  position: relative;
  min-height: 300px;
  background: ${props => props.theme.colors.mainColor};
`;



// WEBPACK FOOTER //
// ./src/containers/VolleyCalendar/styles.js